webpackJsonp([113622635025737],{

/***/ 464:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulBlogPost":{"title":"The Manila Street Astronomers and Spiderman","publicationDate":"December 05, 2017","content":{"content":"![The Manila Street Astronomers and Spiderman Thumbnail](//images.contentful.com/1o5ly3na7qu2/38D7dV3544i244QO24UoUq/aef14290f63889ec30731449e0060ac5/blog_ad_AstroPH.jpg)\n\nFeatured in the last quarter issue of Astronomy PH for 2017 is Gary Andreassen's  \"Manila Street Astronomers: The Official History... Kinda - Part 01\" and Per Edman's \"Spiderman\"\n\nYou can download the feature at [this link](https://tinyurl.com/AstroPHv2n4 \"AstroPHv2n4\")."},"thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/38D7dV3544i244QO24UoUq/aef14290f63889ec30731449e0060ac5/blog_ad_AstroPH.jpg"}}}},"pathContext":{"id":"c16mUjtwr3Us2GEWqI8k4As"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-the-manila-street-astronomers-and-spiderman-ee32ca939b912b84c200.js